/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Link from '@atlaskit/link';

const messages = defineMessages({
	unitProfileValue: {
		id: 'organization.audit.log.side-panel.tab-panels.details.unit-section.unit-profile.row-value',
		defaultMessage: 'Go to profile',
		description: 'Value for the unit profile link in audit log unit section',
	},
});

interface UnitProfileLinkProps {
	profileUrl: string;
}

export const UnitProfileLink = ({ profileUrl }: UnitProfileLinkProps): JSX.Element => {
	return (
		<Link href={profileUrl} target="_blank">
			<FormattedMessage {...messages.unitProfileValue} />
		</Link>
	);
};
